import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useBatchSkiptrace = () =>
  useBatchSkiptraceStore(store => store.batchSkiptrace.state)
